<div class="lum-c-global-search__overlay" *ngIf="isVisible">
  <div #searchModalDiv class="lum-c-global-search__modal">

    <div class="lum-c-global-search__input-wrapper">
      <div class="lum-c-global-search__input-container">
        <span class="lum-c-global-search__search-icon">
          <!-- Assuming you have an SVG or icon font class for search -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px" height="20px"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
        </span>
        <input #searchInput 
               type="text" 
               [placeholder]="(activeResultType$ | async) === 'history' && (recentSearches$ | async)?.length > 0 && activeItemIndex >= 0 ? '' : 'Search Luminous...'"
               (input)="onSearchInput($event)" 
               (keydown.enter)="handleEnterKey()" 
               class="lum-c-global-search__input">
      </div>
      <div class="lum-c-global-search__shortcut-hint">
        <span>Ctrl+K</span>
      </div>
    </div>

    <div class="lum-c-global-search__content-area">
      <!-- Display History -->
      <div #historyContainer class="lum-c-global-search__history-container" *ngIf="showHistory && (recentSearches$ | async)?.length > 0">
        <h4 class="lum-c-global-search__history-title">RECENT SEARCHES</h4>
        <ul>
          <li *ngFor="let term of displayedHistory; let i = index"
              (click)="searchFromHistory(term); $event.stopPropagation()"
              class="lum-c-global-search__history-item"
              [class.lum-c-global-search__history-item--active]="isHistoryItemActive(i)">
            <!-- Using a history/refresh icon -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px" class="lum-c-global-search__history-item-icon"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.959 8.959 0 0 0 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>
            {{ term }}
          </li>
        </ul>
      </div>

      <!-- Display Search Results -->
      <div class="lum-c-global-search__results-container" *ngIf="!showHistory && currentSearchTermValue" #resultsContainer>
          <!-- No Results Message: Show if NOT loading AND there are effectively no results to display -->
          <div *ngIf="!isLoading && !isApiLoading && results && displayedResultGroups.length === 0 && currentSearchTermValue?.length >= 1" class="lum-c-global-search__no-results">
            No results found for "<strong>{{ currentSearchTermValue }}</strong>".
          </div>

          <!-- Results Groups - Render if there are results to show -->
          <div *ngIf="results && displayedResultGroups.length > 0">
              <div *ngFor="let groupName of displayedResultGroups" class="lum-c-global-search__result-group">
                <!-- Render Pages group if it has data -->
                <ng-container *ngIf="groupName === 'Pages' && results[groupName]?.length > 0">
                    <h3 class="lum-c-global-search__group-title">Pages</h3>
                    <ul class="lum-c-global-search__items-list lum-c-global-search__items-list--pages">
                        <li *ngFor="let item of results[groupName]; let i = index"
                            (click)="navigateTo(item)"
                            class="lum-c-global-search__result-item lum-c-global-search__result-item--page"
                            [class.lum-c-global-search__result-item--active]="isResultItemActive(item)">
                            <span>{{ item.label }}</span>
                        </li>
                    </ul>
                </ng-container>

                <!-- Render other (API) groups only if they have data AND API is NOT currently loading new data -->
                 <ng-container *ngIf="groupName !== 'Pages' && results[groupName]?.length > 0 && !isApiLoading">
                     <h3 class="lum-c-global-search__group-title">{{ groupName === 'MTShipstationOrder' ? 'Orders' : groupName === 'AssemblyOrder' ? 'Assemblies' : groupName === 'Picklist' ? 'Picklists' : groupName === 'RequestForQuote' ? 'Products' : groupName === 'MTPurchaseOrder' ? 'Purchase Orders' : groupName === 'API_Error' ? 'Error' : groupName }}</h3>
                     <ul class="lum-c-global-search__items-list">
                         <li *ngFor="let item of results[groupName]; let i = index"
                             (click)="navigateTo(item)"
                             class="lum-c-global-search__result-item"
                             [class.lum-c-global-search__result-item--active]="isResultItemActive(item)">
                             <span>{{ item.label }}</span>
                         </li>
                     </ul>
                 </ng-container>
              </div>
          </div>

          <!-- API Specific Loading Indicator: Shows only when isApiLoading is true -->
          <div *ngIf="isApiLoading" class="lum-c-global-search__api-loading-spinner">
              Loading other results...
          </div>
      </div>
    </div>

    <div class="lum-c-global-search__footer-hints">
      <span class="lum-c-global-search__nav-hint">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16px" height="16px"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" /></svg>
        to navigate
      </span>
      <span class="lum-c-global-search__select-hint">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16px" height="16px"><path fill-rule="evenodd" d="M2.5 12.5a.5.5 0 010-1h15a.5.5 0 010 1h-15z" clip-rule="evenodd" /><path fill-rule="evenodd" d="M4.738 10.738a.5.5 0 01.708 0l3 3a.5.5 0 01-.708.708l-3-3a.5.5 0 010-.708z" clip-rule="evenodd" /><path fill-rule="evenodd" d="M4.738 6.262a.5.5 0 01.708 0l3 3a.5.5 0 010 .708L5.446 10A.5.5 0 014.75 10l-.012-.012a.5.5 0 010-.707l3-3zM10 1.75a.75.75 0 00-.75.75v15.19l-2.72-2.72a.75.75 0 00-1.06 1.06l4.25 4.25a.75.75 0 001.06 0l4.25-4.25a.75.75 0 10-1.06-1.06L10.75 17.69V2.5A.75.75 0 0010 1.75z" clip-rule="evenodd" /></svg> <!-- Placeholder, replace with actual return/enter key icon -->
         to select
      </span>
      <span class="lum-c-global-search__esc-hint"><strong>Esc</strong> to close</span>
    </div>

  </div>
</div> 